// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop .atvvF1{display:flex;justify-content:center}.desktop .WHunsh{width:600px;padding:60px 60px 163px 60px}.desktop .bM1htT{margin-bottom:18px;opacity:0.6}.desktop .Zn_xmn{margin:0 8px}.desktop .t3KJ2c{word-break:break-word}.mobile .WHunsh{padding:24px 20px 94px 20px}.mobile .bM1htT{margin-bottom:8px;opacity:0.6}.mobile .Zn_xmn{margin:0 8px}.mobile .t3KJ2c{word-break:break-word}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyWrapper": `atvvF1`,
	"bodyContainer": `WHunsh`,
	"episodeMetaInfo": `bM1htT`,
	"episodeMetaDotDivider": `Zn_xmn`,
	"episodeDescription": `t3KJ2c`
};
export default ___CSS_LOADER_EXPORT___;
